import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { IntroText } from "./Introtext";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils";
import { usePreferences } from "../../hooks";

const useClasses = makeStyles({
  spanBlock: {
    display: "block"
  }
});

const PatientDetails = ({ name, dob }) => {
  const classes = useClasses();
  const { t } = useTranslation();
  const { dateFormat } = usePreferences();

  return (
    <IntroText>
      {name && (
        <Box
          component="span"
          className={classes.spanBlock}
          data-cy="patient-details-name"
        >
          <strong>{name}</strong>
        </Box>
      )}
      {dob && (
        <Box
          component="span"
          className={classes.spanBlock}
          data-cy="patient-details-dob"
        >
          <strong>
            {t("components.patient_details.date_of_birth")} (
            {formatDate(dob, "MM/DD/YYYY", dateFormat.default)})
          </strong>
        </Box>
      )}
    </IntroText>
  );
};

export { PatientDetails };
